import { render, staticRenderFns } from "./CodeSandbox.vue?vue&type=template&id=099916b8&scoped=true&"
import script from "./CodeSandbox.vue?vue&type=script&lang=js&"
export * from "./CodeSandbox.vue?vue&type=script&lang=js&"
import style0 from "./CodeSandbox.vue?vue&type=style&index=0&id=099916b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "099916b8",
  null
  
)

export default component.exports